import { Controller } from '@hotwired/stimulus';
import { translate } from '../../utils/translation';
import { debounce } from '../../utils/debounce';

const EVENTS = [
  ['change', {}],
  ['select:input-change', {}],
  ['inputs--settlement-select:change', {}],
];

const DEBOUNCE_DELAY = 500;

export default class CountController extends Controller {
  static targets = ['counter', 'form', 'spinner'];

  connect() {
    this.debouncedUpdate = debounce(this.updateCount, DEBOUNCE_DELAY);
    EVENTS.forEach(([event, opts]) => this.element.addEventListener(event, this.handleChange, opts));
  }

  disconnect() {
    EVENTS.forEach(([event, opts]) => this.element.removeEventListener(event, this.handleChange, opts));
  }

  handleChange = () => {
    this.debouncedUpdate();
  };

  setLoadingState = (isLoading) => {
    this.spinnerTargets.forEach((spinner) => spinner.classList.toggle('d-none', !isLoading));
    this.counterTargets.forEach((counter) => counter.classList.toggle('d-none', isLoading));
  };

  updateCount = () => {
    if (!this.hasFormTarget) {
      return;
    }

    this.setLoadingState(true);

    fetch(window.location.href, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(this.formTarget),
    })
      .then((response) => response.json())
      .then((json) => {
        if (this.hasCounterTarget && json.total !== undefined) {
          const formattedCount = new Intl.NumberFormat(document.documentElement.lang).format(json.total);
          this.counterTargets.forEach((target) => {
            target.textContent = translate('pages.listing.search.button_count', { count: formattedCount });
          });
        }
      })
      .catch((error) => {
        console.error('Error updating count:', error);
      })
      .finally(() => {
        this.setLoadingState(false);
      });
  };
}
